import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { CustomActiveCartService } from '@cart/data-access';
import { Observable, Subject, Subscription, interval } from 'rxjs';
import { debounce, filter, tap } from 'rxjs/operators';

// специальная имплементация
// сейчас в корзине много лишних запросов корзины.
// пока они выполняются, сэтить новую активную корзинку нельзя, результат будет непредсказуем
// сэтит зашериную корзину как основную, после того, как у нас кончаются перезапросы корзины
@Injectable({ providedIn: 'root' })
export class CartInterceptor implements HttpInterceptor, OnDestroy {
  debounceCartRefresher$: Subject<HttpRequest<any>> = new Subject();
  addRefreshParam: boolean;
  cartUrls: Array<string> = ['/carts/'];
  cartRefreshFilter = /(?:SetActiveClonnedCartRequest)\/\S+(?:\/)/gm;
  subscription = new Subscription();

  constructor(private customActiveCartService: CustomActiveCartService) {
    this.subscription.add(
      this.debounceCartRefresher$
        .pipe(
          filter((request) => this.isCartRequest(request)),
          debounce(() => interval(500)),
          tap(() => {
            this.addRefreshParam = true;
            this.customActiveCartService.setActiveClonnedCart();
          }),
        )
        .subscribe(),
    );
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToHandle = request;

    if (this.isCartRefreshRequest(request) && this.addRefreshParam) {
      requestToHandle = request.clone({
        params: request.params.set('SetActiveClonnedCartRequest', `${this.addRefreshParam}`),
      });
      this.addRefreshParam = false;
    }

    return next.handle(requestToHandle).pipe(
      tap(() => {
        this.debounceCartRefresher$.next(requestToHandle);
      }),
    );
  }

  isCartRequest(request: HttpRequest<any>): boolean {
    return this.cartUrls.some((checkoutUrlSubstring) => request.url.includes(checkoutUrlSubstring));
  }

  isCartRefreshRequest(request: HttpRequest<any>): boolean {
    return request.method === 'GET' && !this.cartRefreshFilter.test(request.url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
